import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";
import { MapPin, ArrowUpRight } from "lucide-react";
import { locationPath } from "../lib/useSeo";

export function AreasWeCover() {
  const [areas, setAreas] = useState([]);
  useEffect(() => { api.get("/areas").then((r) => setAreas(r.data)).catch(() => {}); }, []);

  return (
    <section id="areas" className="section-pad" data-testid="areas-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4 lg:sticky lg:top-28">
          <Reveal>
            <span className="overline">Areas We Cover</span>
            <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
              Driving lessons in our <span className="brand-text">local areas</span>
            </h2>
            <p className="mt-4 text-neutral-500 leading-relaxed">
              We provide manual and automatic driving lessons across Northolt, Greenford, Southall and South Harrow.
            </p>
            <div className="mt-6 rounded-3xl overflow-hidden shadow-soft border border-neutral-100">
              <iframe
                title="SUK coverage map"
                src="https://www.google.com/maps?q=Northolt,+UB5&output=embed"
                className="w-full h-64 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {areas.map((a, i) => (
            <Reveal key={a.id} delay={(i % 3) * 0.06}>
              <Link
                to={locationPath(a.slug)}
                className="group block relative rounded-3xl overflow-hidden h-52 shadow-soft"
                data-testid={`area-card-${a.slug}`}
              >
                <img src={a.image} alt={`Driving lessons in ${a.name}`} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" width="800" height="600" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 text-white">
                  <p className="flex items-center gap-1.5 text-xs text-white/80"><MapPin size={13} /> {a.postcodes}</p>
                  <h3 className="font-heading text-xl font-bold flex items-center justify-between">
                    {a.name}
                    <ArrowUpRight size={20} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
                  </h3>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
